export class ShebaHttpConfig {
    endPoint?: string
}
